export default __webpack_public_path__ + "static/media/bg_login.42e254c8.jpeg";